export const states = [
    { label: 'Acre', key: 'AC' },
    { label: 'Alagoas', key: 'AL' },
    { label: 'Amapá', key: 'AP' },
    { label: 'Amazonas', key: 'AM' },
    { label: 'Bahia', key: 'BA' },
    { label: 'Ceará', key: 'CE' },
    { label: 'Distrito Federal', key: 'DF' },
    { label: 'Espírito Santo', key: 'ES' },
    { label: 'Goiás', key: 'GO' },
    { label: 'Maranhão', key: 'MA' },
    { label: 'Mato Grosso', key: 'MT' },
    { label: 'Mato Grosso do Sul', key: 'MS' },
    { label: 'Minas Gerais', key: 'MG' },
    { label: 'Pará', key: 'PA' },
    { label: 'Paraíba', key: 'PB' },
    { label: 'Paraná', key: 'PR' },
    { label: 'Pernambuco', key: 'PE' },
    { label: 'Piauí', key: 'PI' },
    { label: 'Rio de Janeiro', key: 'RJ' },
    { label: 'Rio Grande do Norte', key: 'RN' },
    { label: 'Rio Grande do Sul', key: 'RS' },
    { label: 'Rondônia', key: 'RO' },
    { label: 'Roraima', key: 'RR' },
    { label: 'Santa Catarina', key: 'SC' },
    { label: 'São Paulo', key: 'SP' },
    { label: 'Sergipe', key: 'SE' },
    { label: 'Tocantins', key: 'TO' },
];
